import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './index.css';
import { JobDetailsHeader, JobDetailSkills, JobDetailDescription } from './components';
import { pushLog2DV2LogServer } from '../../../../services/logging';
import { PageConstant } from '../../../../constants';

const JobDetailContainer = ({ job = {}, history }) => {
  const onStartTest = (mcq_name, mcq_id, accChallenge = 0) => {
    const name = mcq_name.replace(/\s/g, '-');
    pushLog2DV2LogServer.info('START_MCQ_FROM_JOB', 'START_MCQ_FROM_JOB_DETAIL', {}, { jobId: job.id, mcq_id }, null);
    if (history) {
      if (+accChallenge) history.push(`${PageConstant.CODING_CHALLENGE}`);
      else history.push(`/dashboard/turing_test/${name}/${mcq_id}`);
    } else {
      if (+accChallenge) window.open(`${PageConstant.CODING_CHALLENGE}`, '_self');
      else window.open(`/dashboard/turing_test/${name}/${mcq_id}`, '_self');
    }
  };

  useEffect(() => {
    if (window.scrollTo) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    }
  }, []);

  return (
    <div>
      {
        job
          ? (
            <div>
              <JobDetailsHeader
                title={job.title}
                seniority={job.seniority}
              />
              <JobDetailSkills skills={job.skills.filter(s => s.linked_mcq_id)} onStartTest={onStartTest} />
              <JobDetailDescription description={job.description} />
            </div>
          )
          : null
      }
    </div>
  );
};

JobDetailContainer.propTypes = {
  job: PropTypes.object,
  history: PropTypes.any
};

export default JobDetailContainer;
